import React from "react";
import Icon from "./Icon";
export const renderIcon = (iconName, size, extraProps) => {
    if (!iconName) {
        return undefined;
    }
    const iconProps = Object.assign({ h: "1em", w: "1em", m: 0, size }, extraProps);
    if (typeof iconName === "string") {
        return React.createElement(Icon, Object.assign({ icon: iconName }, iconProps));
    }
    return React.createElement(Icon, Object.assign({ as: iconName }, iconProps));
};
//# sourceMappingURL=iconHelpers.js.map